import request from "@/app/api/request";
import {
  CaptchaResponseModel,
  ErrorModel,
  LoginWithPinModel, LoginWithPinResponseModel, RegisterRequestModel,
  SendOtpModel,
  SendOtpResponseModel,
  VerifyOtpModel,
  VerifyOtpResponseModel
} from "./models";
import {MessagesModel} from "@/app/api/chat";

export class AuthRequests {
  static async getCaptcha(): Promise<CaptchaResponseModel> {
    try {
      return await request.get<CaptchaResponseModel>('auth/captcha', {});
    } catch (error: any) {
      throw error;
    }
  }

  static async sendOtp(model: SendOtpModel) {
    try {
      return await request.post<SendOtpResponseModel>('auth/sendOtp', {query: model});
    } catch (error: any) {
      throw error;
    }
  }

  static async verifyOtp(model: VerifyOtpModel) {
    try {
      return await request.post<VerifyOtpResponseModel>('auth/verifyOtp', {query: model});
    } catch (error: any) {
      throw error;
    }
  }

  static async loginWithPin(model: LoginWithPinModel) {
    try {
      return await request.post<LoginWithPinResponseModel>('auth/loginWithPin', {query: model});
    } catch (error: any) {
      throw error;
    }
  }

  static async register(model: any): Promise<ErrorModel> {
    try {
      return await request.post<ErrorModel>('auth/register', {data: model});
    } catch (error: any) {
      throw error;
    }
  }
}

